// Carnival Sale Timer — recurring interval countdown, scoped to this section
// only (not loaded theme-wide). Boundary math mirrors the verified Rakhi Sale
// timer (assets/rakhi-sale.js): countdown resets on fixed IST-aligned
// boundaries every `intervalHours` (12h -> 12AM/12PM IST, 8h -> 12AM/8AM/4PM,
// etc.) and loops until `data-sale-end` is reached, then hides.
//
// Runs once, on script execution: this <script> has `defer`, so every timer
// element already exists in the DOM by the time this runs — no scan-on-
// mutation needed. Unlike Rakhi's timer, this one has no cart-drawer copy
// rendered via the Section Rendering API, so there's no innerHTML-injected
// instance that would need re-discovering after the fact.
//
// Trade-off (deliberate): if a merchant edits this section's settings inside
// the Theme Editor, Shopify replaces its HTML via innerHTML, which doesn't
// re-run this script — the preview would need a refresh to tick again.
// Accepted in exchange for not running a MutationObserver for the entire
// lifetime of every real visitor's page view.
(function () {
  'use strict';

  var IST_OFFSET = 5.5 * 3600000;

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  // Next recurring boundary as a real UTC timestamp, aligned to IST midnight.
  function nextBoundary(nowMs, intervalMs) {
    var istNowMs = nowMs + IST_OFFSET;
    var istMidnightMs = Math.floor(istNowMs / 86400000) * 86400000;
    var elapsed = istNowMs - istMidnightMs;
    var k = Math.floor(elapsed / intervalMs) + 1;
    var boundaryIstMs = istMidnightMs + k * intervalMs;
    return boundaryIstMs - IST_OFFSET;
  }

  function initTimer(el) {
    if (el._carnivalTimerInited) return;
    el._carnivalTimerInited = true;

    var saleEnd = new Date(el.getAttribute('data-sale-end')).getTime();
    var intervalMs = (parseFloat(el.getAttribute('data-interval-hours')) || 12) * 3600000;
    var hrsEl = el.querySelector('[data-carnival-timer-hrs]');
    var minEl = el.querySelector('[data-carnival-timer-min]');
    var secEl = el.querySelector('[data-carnival-timer-sec]');

    if (!hrsEl || !minEl || !secEl) return;

    function tick() {
      var now = Date.now();

      if (isNaN(saleEnd) || now >= saleEnd) {
        el.hidden = true;
        return;
      }

      var target = Math.min(nextBoundary(now, intervalMs), saleEnd);
      var diff = Math.max(0, target - now);

      hrsEl.textContent = pad(Math.floor(diff / 3600000));
      minEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      secEl.textContent = pad(Math.floor((diff % 60000) / 1000));

      setTimeout(tick, 1000);
    }

    tick();
  }

  document.querySelectorAll('.carnival-sale-timer[data-sale-end]').forEach(initTimer);
})();
